
[
  {
    "id": "GELD-L5-001",
    "module": "TijdGeld",
    "difficulty": 202,
    "question": "Een pak sap van 1,5 liter kost € 2,40. Een pak van 2 liter kost € 3,10. Welke is per liter goedkoper?",
    "options": ["1,5 liter", "2 liter", "Even duur", "Niet te zeggen"],
    "correctAnswer": 1,
    "questionType": "multiple_choice",
    "skill": "geld_rekenen",
    "subSkill": "prijzen_vergelijken",
    "familyId": "GELD-PRIJS-VERGELIJKEN",
    "explanation": "Bereken de literprijs. 1,5 liter: € 2,40 : 1,5 = € 1,60 per liter. 2 liter: € 3,10 : 2 = € 1,55 per liter. Het pak van 2 liter is per liter goedkoper.",
    "distractorExplanations": {
      "0": "Het pak van 1,5 liter kost € 1,60 per liter. Het pak van 2 liter kost € 1,55 per liter. Het grote pak is dus goedkoper per liter.",
      "2": "Ze zijn niet even duur per liter. Reken de prijs per liter uit door de totaalprijs te delen door het aantal liters.",
      "3": "Je kunt het wel uitrekenen! Deel de prijs door het aantal liters om de literprijs te vergelijken."
    }
  },
  {
    "id": "TIJD-B7P-L5-001",
    "module": "TijdGeld",
    "difficulty": 202,
    "question": "Een busrit duurt 2 uur en 18 minuten. Je bent al 1 uur en 35 minuten onderweg. Hoe lang moet je nog?",
    "options": ["33 minuten", "43 minuten", "53 minuten", "63 minuten"],
    "correctAnswer": 1,
    "questionType": "multiple_choice",
    "skill": "tijdrekenen",
    "subSkill": "tijdsduur_berekenen",
    "familyId": "TIJD-TURBO-REIS",
    "explanation": "Trek de verstreken tijd af: 2 uur 18 min - 1 uur 35 min. De minuten: 18 - 35 kan niet, dus leen 1 uur (= 60 min). Nu: 78 - 35 = 43 minuten. De uren: 2 - 1 - 1 (geleend) = 0 uur. Dus nog 43 minuten.",
    "distractorExplanations": {
      "0": "Je maakte een rekenfout bij het lenen. 18 min - 35 min kan niet, dus je moet 60 minuten lenen: 78 - 35 = 43.",
      "2": "Je rekende 1 uur 18 min - 35 min, maar de totale reistijd is 2 uur 18 min, niet 1 uur 18 min.",
      "3": "Je trok alleen de uren af (2 - 1 = 1 uur) en vergat de minuten goed te verrekenen. 1 uur en 18 min - 35 min = 43 min."
    }
  },
  {
    "id": "GELD-B7P-L5-002",
    "module": "TijdGeld",
    "difficulty": 202,
    "question": "Een rugzak kost € 48,-. Eerst krijg je 25% korting, daarna nog € 6,- korting. Wat betaal je?",
    "options": ["€ 24,-", "€ 30,-", "€ 36,-", "€ 42,-"],
    "correctAnswer": 1,
    "questionType": "multiple_choice",
    "skill": "geld_rekenen",
    "subSkill": "korting",
    "familyId": "GELD-KORTING-DUBBEL",
    "explanation": "Stap 1: 25% korting op € 48. Een kwart van 48 is 12. Dus 48 - 12 = € 36. Stap 2: Nog € 6 korting. 36 - 6 = € 30.",
    "distractorExplanations": {
      "0": "Je rekende 50% korting (de helft van 48 = 24) in plaats van 25%. 25% is een kwart, niet de helft.",
      "2": "Je rekende alleen de 25% korting (48 - 12 = 36) maar vergat de extra € 6 korting eraf te halen.",
      "3": "Je rekende alleen de € 6 korting (48 - 6 = 42) maar vergat de 25% korting. Reken eerst de 25% uit."
    }
  }
]
